import React from 'react';
import ServicePriceCard from './ServicePriceCard';

const ServicePrice = props => {
  const { currency } = props;
  return (
    <div className="bg-white">
      <div className="container py-[48px]">
        <div className="flex h-full justify-center items-center flex-col gap-[48px]">
          <h2 className={'flex justify-center items-center w-full font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px] text-black'}>
            Get a preview of our Guaranteed SEO Services
          </h2>

          <ServicePriceCard currency={currency} />
        </div>
      </div>
    </div>
  );
};

export default ServicePrice;
